{"id":"ProductDetail.Info.AddToCart","prefabs":{"default":{"children":[{"component":"ProductDetail.Info.AddToCart","options":"options:*"}]}}}